(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    /* MJ — keeps the price on the Add to cart button in step with the quantity.
     Horizon re-renders this block on every variant change, so the unit price
     in data-mj-unit is always current. */
  class MjPriceSync extends HTMLElement {
    connectedCallback() {
      this.amount = this.querySelector('.mj-atc-amount');
      this.input = this.querySelector('input[name="quantity"]');
      if (!this.amount || !this.input) return;

      this.unit = parseInt(this.amount.dataset.mjUnit, 10);
      if (isNaN(this.unit)) return;

      const currency = this.amount.dataset.mjCurrency || 'USD';
      try {
        this.fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency,
        });
      } catch (e) {
        this.fmt = null;
      }

      this.base = this.amount.textContent.trim();
      this.update = this.update.bind(this);

      this.input.addEventListener('input', this.update);
      this.input.addEventListener('change', this.update);

      /* the minus and plus buttons set .value directly, which fires no event */
      this.querySelectorAll('button[name="minus"], button[name="plus"]').forEach((btn) => {
        btn.addEventListener('click', () => setTimeout(this.update, 0));
      });

      this.update();
    }

    disconnectedCallback() {
      if (!this.input) return;
      this.input.removeEventListener('input', this.update);
      this.input.removeEventListener('change', this.update);
    }

    update() {
      const qty = Math.max(1, parseInt(this.input.value, 10) || 1);

      /* A quantity of one keeps Shopify's own formatting, which respects the
         store's money format exactly. */
      if (qty === 1) {
        this.amount.textContent = this.base;
        return;
      }

      const total = (this.unit * qty) / 100;
      this.amount.textContent = this.fmt ? this.fmt.format(total) : total.toFixed(2);
    }
  }

  if (!customElements.get('mj-price-sync')) customElements.define('mj-price-sync', MjPriceSync);
  } catch(e) { console.error(e); }
})();

})();
